// Use this to create a grid api service of components which use AG-GRID

import { Injectable } from '@angular/core';
import { GridApi, IRowNode } from 'ag-grid-community';

@Injectable()
export abstract class AgApiService<T> {

  protected _gridApi: GridApi<T>;

  constructor() {
  }

  set gridApi(gridApi: GridApi<T>) {
    this._gridApi = gridApi;
  }

  get gridApi() {
    return this._gridApi;
  }

  scrollRowToView(rowNode: IRowNode<T>, position: 'top' | 'bottom' | 'middle' = 'middle') {
    this._gridApi?.ensureNodeVisible(rowNode, position);
  }
}